import React, { useEffect, useState } from 'react';
import { PrimaryButton, SiteModal } from '../../../../components/common';
import { constants } from '../../../../helpers';
import { Col, Row, ProgressBar } from 'react-bootstrap';
import './LatencyTest.scss';
import { PiCalendarBlankLight } from 'react-icons/pi';
import './ViewDetailsModal.scss';
import moment from 'moment';
import { sizeConvertor } from '../../../../helpers/commonUtils';

const ViewDetailsModal = ({
  showViewDetailsModal,
  setShowViewDetailsModal,
  cgrHubDetails,
  deviceDetails,
}) => {
  const [hubDetails, setHubDetails] = useState(cgrHubDetails?.Channels);

  useEffect(() => {
    setHubDetails(cgrHubDetails?.Channels);
  }, [cgrHubDetails?.Channels]);

  useEffect(() => {
    if (
      deviceDetails &&
      deviceDetails?.channels &&
      deviceDetails?.channels?.length > 0 &&
      cgrHubDetails?.Channels &&
      cgrHubDetails?.Channels?.length > 0
    ) {
      let cameraDetails = cgrHubDetails?.Channels?.map((hub) => {
        let max = cgrHubDetails?.internalDrives?.reduce((acc, drive) => {
          if (drive.status == 'OK' || drive.status == 'At Risk') {
            return acc + drive.totalCapacity;
          }
        }, 0);
        let filteredDevice = deviceDetails?.channels.find(
          (channel) => channel.deviceId === hub.ChannelDeviceID,
        );
        let progress;
        if (hub.DiskSpaceUsage <= 0) {
          progress = 0;
        } else {
          progress = Math.ceil(((100 * hub.DiskSpaceUsage) / max).toFixed(3));
        }
        if (filteredDevice) {
          return {
            ...hub,
            cameraName: filteredDevice.deviceName,
            progress: progress,
          };
        } else {
          return hub;
        }
      });
      setHubDetails(cameraDetails);
    }
  }, [deviceDetails, cgrHubDetails]);

  return (
    <SiteModal
      modalTitle={constants.STORAGE_USAGE}
      showModal={showViewDetailsModal}
      hideModal={() => {
        setShowViewDetailsModal(false);
      }}
      size="lg"
      classes="device-settings-view-details-modal"
    >
      <div className="view-details-modal-container">
        <div className="latency-test-modal-info-section">
          {hubDetails?.map((camera, index) => (
            <div className="device-info-section">
              <Row>
                <Col>
                  <div
                    className="view-details-block-content"
                    style={{
                      color: getComputedStyle(
                        document.documentElement,
                      ).getPropertyValue('--greyscale_08'),
                    }}
                  >
                    {camera.cameraName ? camera.cameraName : '--'}
                  </div>
                </Col>
                <Col sm={5} md={5} lg={5} xl={5} xxl={5}>
                  <div className="used-space">
                    {constants.USED_SPACE} :
                    {camera.DiskSpaceUsage
                      ? sizeConvertor(camera.DiskSpaceUsage)
                      : ' 0 GB'}
                  </div>
                  <div className="modal-progress-bar">
                    <ProgressBar variant="danger" now={camera.progress} />
                  </div>
                </Col>
                <Col>
                  <div className="used-space">{constants.OLDEST_RECORDING}</div>
                  <div className="hub-info-block-content">
                    <div className="block-content">
                      <PiCalendarBlankLight />
                      {camera &&
                      camera.OldestRecording &&
                      camera.OldestRecording > 0
                        ? moment(camera.OldestRecording).format('DD MMM yyyy')
                        : '--'}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          ))}
        </div>
        <PrimaryButton
          className="btn btn-primary-outline mb-2"
          type="button"
          width="100%"
          borderWidth="1.5px"
          hoverBorderWidth="1.5px"
          height="56px"
          fontSize="1.125rem"
          lineHeight="24px"
          onClick={() => {
            setShowViewDetailsModal(false);
          }}
        >
          {constants.CLIP_DETAILS_BACK_BUTTON_LABEL}
        </PrimaryButton>
      </div>
    </SiteModal>
  );
};
export default ViewDetailsModal;
